import { AuthLayout } from '../../components/layout/AuthLayout'
import { DashboardPreview } from '../../components/layout/DashboardPreview'
import { ForgotPasswordForm } from '../../components/forms/ForgotPasswordForm'

export const ForgotPasswordPage = () => {
  return (
    <AuthLayout preview={<DashboardPreview />}>
      <ForgotPasswordForm />
    </AuthLayout>
  )
}
